'use strict';

exports.__esModule = true;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _widgetsUtils = require('widgets-utils');

var _layouts = require('../utils/layouts');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DoctifyWfGrid = function (_WfAbstractComponent) {
    (0, _inherits3.default)(DoctifyWfGrid, _WfAbstractComponent);

    function DoctifyWfGrid() {
        (0, _classCallCheck3.default)(this, DoctifyWfGrid);
        return (0, _possibleConstructorReturn3.default)(this, _WfAbstractComponent.apply(this, arguments));
    }

    DoctifyWfGrid.prototype.render = function render() {
        var props = this.props;
        switch (props.layoutType) {
            case _layouts.WF_GRID_A:
                return (0, _layouts.Grid_A)(props);
            case _layouts.WF_GRID_B:
                return (0, _layouts.Grid_B)(props);
            default:
                return (0, _layouts.Grid_A)(props);
        }
    };

    return DoctifyWfGrid;
}(_widgetsUtils.WfAbstractComponent);

DoctifyWfGrid.displayName = 'DoctifyWfGrid';

DoctifyWfGrid.defaultProps = {
    reviews: [],
    layoutType: _layouts.WF_GRID_A,
    wrapperFrame: true
};

exports.default = DoctifyWfGrid;